export const Header = (function () {
	'use strict';

	let $menu, $menuButton, $subMenuParent, $subMenuItem, $body, $cookieBanner;

	function init() {
		($menu = $('.site-header__nav .nav-items')), ($menuButton = $('.mobile-menu-button'));
		$body = $('body');
		$subMenuParent = $('.site-header .menu-item-has-children');
		$subMenuItem = $('.site-header .sub-menu a');
		$cookieBanner = $('.cookie-banner');

		$body.css('overflow-x', 'auto');

		setTimeout(function() {
			$body.css('overflow-x', 'hidden');
		}, 200);

		events();
	}

	function events() {
		$menuButton.click(function () {
			if ($menu.hasClass('open')) {
				$body.removeClass('mobile-menu-open');
				$menu.removeClass('open');
				$menuButton.removeClass('open').attr('aria-expanded', 'false');
			} else {
				$body.addClass('mobile-menu-open');
				$menu.addClass('open');
				$menuButton.addClass('open').attr('aria-expanded', 'true');
			}

			$( '.mobile-menu-button--open' ).click( function ( ) {
				$body.removeClass('mobile-menu-open');
				$menu.removeClass('open');
				$menuButton.removeClass('open').attr('aria-expanded', 'false');
			} );
		});

		const mobileNavItemsWithChildren = document.querySelectorAll('.nav-items--mobile ul > li.menu-item-has-children');

		if (mobileNavItemsWithChildren.length === 0) return;

		mobileNavItemsWithChildren.forEach((item) => {

			// jquery both events touchstart and click

			$( item ).find( 'div.expand' ).on( 'click', function ( ev ) {
				if (ev.cancelable) ev.preventDefault();

				item.classList.toggle('active');

				$( item ).find( '.plus-minus-toggle' ).toggleClass( 'collapsed' );
			} );


			// item.querySelector('div.expand').addEventListener('touchstart', (ev) => {
			// 	if (ev.cancelable) ev.preventDefault();

			// 	item.classList.toggle('active');

			// 	$( item ).find( '.plus-minus-toggle' ).toggleClass( 'collapsed' );
			// });

			// item.querySelector('div.expand').addEventListener('click', (ev) => {
			// 	ev.preventDefault();
			// 	item.classList.toggle('active');
			// });
		});

		document.onkeydown = function(evt) {
		    evt = evt || window.event;
		    if (evt.keyCode == 27) {
					$('a').blur();
		    }
		};

		if ($cookieBanner) {
			cookieBannerResize();
			$(window).on('resize', cookieBannerResize);
		}
	}

	function cookieBannerResize(){
		let $cookieBannerHeight = $cookieBanner.outerHeight();
		let $headerHeight = $( '.site-header' ).outerHeight();

		if ($(window).width() < 1024) {
			$('.nav-items--mobile').css({
				// 'top': $cookieBannerHeight + $headerHeight,
				'height': 'calc(100vh - ' + ( $cookieBannerHeight + $headerHeight ) + 'px)'
			});
		}
	}

	return {
		init: init,
	};
})();
